export function textWithAccent(value) {
    let fixValue = value.replace('\\U', '\\u');

    return JSON.parse('"' + fixValue + '"');
}


export function dataTableTextWithAccent(rowData, column) {
    return textWithAccent(rowData[column.field]);
}

export function replaceAccents(value) {
    let accents = [
        {html: /&aacute;/g, letter: "á"}, {html: /&Aacute;/g, letter: "Á"},
        {html: /&eacute;/g, letter: "é"}, {html: /&Eacute;/g, letter: "É"},
        {html: /&iacute;/g, letter: "í"}, {html: /&Iacute;/g, letter: "Í"},
        {html: /&oacute;/g, letter: "ó"}, {html: /&Oacute;/g, letter: "Ó"},
        {html: /&uacute;/g, letter: "ú"}, {html: /&Uacute;/g, letter: "ú"}];

    accents.forEach(accentVal => {
        value = value.replace(accentVal['html'], accentVal['letter']);
    });
    return value;
}

export function replaceDiacriticsUni(text){
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g,"");
}

export function deleteNonNumericPint(text){
    return text.replace(/\D/g,'');
}

export function deleteSpecialChars(text){
    let specialChars= /[-|+|.|^|:|,|@|*|(|)|{|}|%|!|"|#|$|&|/|=|?|¡|¿]/g;
    return text.replace(specialChars,'');
}
